import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

const STAFF_HOME = { admin: '/admin/assistant', installer: '/installer/dashboard' };

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={STAFF_HOME[user?.role] || '/home'} />;
  }

  return <>{children}</>;
}
